import React from "react";
import { Slider } from "../../../components/slider/slider";
import { SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../AppContext";
import Counter from "../../../components/increaser-decreaser/counter";
import { Product, accessories } from "../../../file.interface";
import { formatAsEuro } from "../../../helpers/helpers";
import Table from "../../../components/dynamic-table/general-dynamic-table";

export interface SelectedAccessory extends Product {
  counter: number;
}

const AccessoriesScreen2: React.FC = () => {
  //
  const navigate = useNavigate();
  const {
    selectedContractDuration,
    flowAccessories,
    flowDevices,
    flowCardMachines,
    dispatch,
    selectedSiteFlow,
    sites,
    isNewSite,
  } = useAppContext();

  const handleNextStep = () => {
    if (isNewSite) {
      dispatch({
        type: "UPDATE_CONTEXT",
        payload: {
          sites: sites.concat({
            name: "SITE #" + (selectedSiteFlow + 1),
            cart: [...flowAccessories, ...flowDevices, ...flowCardMachines],
          }),
          flowDevices: [],
          flowCardMachines: [],
          flowAccessories: [],
        },
      });
    } else {
      const _sites = [...sites];

      _sites[selectedSiteFlow].cart = [
        ...flowAccessories,
        ...flowDevices,
        ...flowCardMachines,
      ];

      dispatch({
        type: "UPDATE_CONTEXT",
        payload: {
          sites: _sites,
          flowDevices: [],
          flowCardMachines: [],
          flowAccessories: [],
        },
      });
    }

    navigate("/sites-screen-3");
  };

  return (
    <div className="screen-container">
      <h3 className="title-screen">SITE #{selectedSiteFlow + 1}</h3>

      <h4 className="subtitle-screen">Choose your accessories</h4>
      <Slider
        breakpoints={{
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        }}
      >
        {accessories?.map((product, index) => (
          <SwiperSlide key={index}>
            <div className="product-card">
              <div style={{ textAlign: "center" }} className="image-container">
                <img
                  src={product.imageUrl}
                  alt={product.name}
                  style={{ width: "100%", maxWidth: 250 }}
                />
              </div>
              <div style={{ padding: 20 }}>
                <h3 className="card-title">{product.name}</h3>
                <Counter product={product} flow={flowAccessories} />
                <p className="price-by-unit">
                  Price by unit:{" "}
                  {formatAsEuro(product.prices[selectedContractDuration])}{" "}
                  monthly
                </p>
                <p>{product.description}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Slider>

      {flowAccessories.length > 0 && (
        <>
          {/* <h3 className="title-screen">Summary</h3> */}
          <Table items={flowAccessories} />
        </>
      )}
      <div className="buttons-container">
        <button
          className="app-button previous-button"
          onClick={() => navigate(-1)}
        >
          Previous
        </button>
        <button
          className={`app-button next-button`}
          onClick={() => handleNextStep()}
        >
          {flowAccessories.length > 0 ? "Next" : "Skip"}
        </button>
      </div>
    </div>
  );
};

export default AccessoriesScreen2;
